export const getDefaultValues = (gameWikiDetails) => ({
  GameWikiTitle: gameWikiDetails?.GameWikiTitle || '',
  GameWikiIsShort: gameWikiDetails?.GameWikiIsShort ? true : false,
  GameWikiSourceUrl: gameWikiDetails?.GameWikiSourceUrl || '',
});
